import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    landscape: {
      baseWidth: width,
      baseHeight: height,
      scaleCoeff: {
        scale: 1.5,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-70),
        y: convertToPercentageY(114 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(90),
        y: convertToPercentageY(186 + yOffset),
        duration: 170,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    landscape: {
      scaleCoeff: {
        scaleX: 3,
        scaleY: 2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(320),
        y: convertToPercentageY(0),
        alpha: 0,
        scaleX: 1,
        scaleY: 0.06,
      },
      {
        wait: 335,
        callback: () => {
          G.sfx.corruption.play();
        },
      },
      {
        y: convertToPercentageY(75),
        alpha: 1,
        scaleY: 0.18,
        duration: 120,
      },
      {
        y: convertToPercentageY(564),
        scaleY: 1.4,
        duration: 435,
      },
    ],
  },
];
